document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('newsletterForm');
  if (form) {
    const emailInput = form.querySelector('input[name="email"]');
    const errorMsg = form.querySelector('.error-msg');
    const successMsg = form.querySelector('.success-msg');

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = emailInput.value;

      fetch(
        'https://toddshelton-ecom-next.vercel.app/api/mailchimp/subscribe',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            customerEmail: email,
            fname: email,
            lname: email,
            area: 'Blog Footer Sign Up',
            referrer: `${window.location.origin}${window.location.pathname}`,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            errorMsg.textContent = data.error;
            errorMsg.style.display = 'block';
            successMsg.style.display = 'none';
          } else {
            form.classList.add('success');
            successMsg.textContent = data.message;
            successMsg.style.display = 'block';
            errorMsg.style.display = 'none';
            emailInput.value = '';
          }
        });
    });
  }
});
